/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore'], function(backbone, _) {
    var AttributeModel;

    var intAttributeNames = ['max_side_count', 'resolution', 'shape', 'orientation'];
    var floatAttributeNames = ['fullbleed_height', 'nonbleed_width', 'nonbleed_height', 'safezone_width', 'fold_line_lin'];

    return (AttributeModel = backbone.Model.extend(
        {
            defaults: {
                name: null,
                title: null,
                value: null
            },

            getValue: function() {
                return this.get('value');
            },

            /**
             * @param {Object} options
             * @returns {AttributeModel}
             */
            fromDTO: function(options) {
                var _this = this;
                _.each(AttributeModel.DTOMap, function(mappedName, attributeName) {
                    if (options[mappedName] !== undefined) {
                        _this.set(attributeName, options[mappedName]);
                    }
                });
                if (intAttributeNames.indexOf(this.get('name')) !== -1) {
                    _this.set('value', parseInt(this.get('value')));
                } else if (floatAttributeNames.indexOf(this.get('name')) !== -1) {
                    _this.set('value', parseFloat(this.get('value')));
                }
                return this;
            }
        },
        {
            DTOMap: {
                name: 'name',
                title: 'quantity',
                value: 'value'
            },

            NAME_DVS_CRITERIA_NAME: 'dvs_criteria_name',
            NAME_FOLD_LINE: 'fold_line_lin',
            NAME_FULLBLEED_HEIGHT: 'fullbleed_height',
            NAME_FULLBLEED_WIDTH: 'fullbleed_width',
            NAME_LINEAR_UNIT_SIGN: 'linear_unit_sign',
            NAME_MAX_SIDE_COUNT: 'max_side_count',
            NAME_NONBLEED_HEIGHT: 'nonbleed_height',
            NAME_NONBLEED_WIDTH: 'nonbleed_width',
            NAME_ORIENTATION: 'orientation',
            NAME_RESOLUTION: 'resolution',
            NAME_SAFEZONE_HEIGHT: 'safezone_height',
            NAME_SAFEZONE_WIDTH: 'safezone_width',
            NAME_START_PAGE_WIDTH: 'startpage_width',
            NAME_START_PAGE_HEIGHT: 'startpage_height',
            NAME_SHAPE: 'shape',

            NAME_FOLD_INSIDE_LEFT: 'fold_inside_left',
            NAME_FOLD_INSIDE_CENTER: 'fold_inside_center',
            NAME_FOLD_INSIDE_RIGHT: 'fold_inside_right',
            NAME_FOLD_OUTSIDE_LEFT: 'fold_outside_left',
            NAME_FOLD_OUTSIDE_CENTER: 'fold_outside_center',
            NAME_FOLD_OUTSIDE_RIGHT: 'fold_outside_right',
            NAME_PRODUCT_SIZE_DESCRIPTION: 'product_size_description',

            VALUE_ORIENTATION_LANDSCAPE: 0,
            VALUE_ORIENTATION_PORTRAIT: 1,
            VALUE_ORIENTATION_BOTH: 2,

            VALUE_SHAPE_RECTANGULAR: 0,
            VALUE_SHAPE_CIRCLE: 1
        }
    ));
});
